import { useTranslation } from "react-i18next";

import { usePersonOib } from "../hooks";
import { AlternativeDocumentInfo } from "./AlternativeDocumentInfo";
import {
  ChildOverviewProps,
  ChildPersonalDataSection,
  ChildResidenceSection,
  ChildStaySection,
} from "./child-overview";
import { FormCard, InfoPanel } from "../../../../components";
import { SectionHeader } from "../../../../components/FormControls";
import { PersonIdentification } from "../../../../models/Shared/PersonIdentification";

interface IProps extends ChildOverviewProps {
  childIdentification?: PersonIdentification;
}

export const ChildOverviewAccordion = ({
  childDetails,
  onUpdate,
  childIdentification,
}: IProps) => {
  const { t } = useTranslation();
  const {
    isLoading,
    fetchPersonDetailsByOib,
    canApply,
    applyFetchedData,
    data: fetchedData,
    successMessage,
  } = usePersonOib();

  const userOib = childDetails.person?.oib ?? childIdentification?.oib ?? "";

  const handleRefresh = () => {
    if (!userOib) return;
    fetchPersonDetailsByOib(userOib);
  };

  const handleApply = () => {
    const fetched = applyFetchedData();
    if (fetched) {
      onUpdate({ ...fetched, nationalityId: childDetails.nationalityId });
    }
  };

  return (
    <FormCard className="position-relative">
      {successMessage && (
        <InfoPanel color="success" fullWidth>
          {t(successMessage)}
        </InfoPanel>
      )}
      <SectionHeader
        title={t("enrollmentForm.sections.childOverview")}
        actionButton={{
          canApply,
          handleApply,
          handleRefresh,
          isLoading,
          isHidden: !userOib,
        }}
      />
      <AlternativeDocumentInfo
        personIdentification={childIdentification}
        userOib={userOib}
      />
      <ChildPersonalDataSection
        childDetails={childDetails}
        onUpdate={onUpdate}
        fetchedData={fetchedData}
        canApply={canApply}
        userOib={userOib}
      />
      <ChildResidenceSection
        childDetails={childDetails}
        onUpdate={onUpdate}
        fetchedData={fetchedData}
        canApply={canApply}
      />
      <ChildStaySection
        childDetails={childDetails}
        onUpdate={onUpdate}
        fetchedData={fetchedData}
        canApply={canApply}
      />
    </FormCard>
  );
};
